// Widget Scripts
import ticketButton from './js/widgets/ticketButton.js';
import videoWidget from './js/widgets/videoWidget.js';
import multiScheduleFeature from './js/widgets/multiScheduleFeature.js';
import seoWidget from './js/widgets/seoWidget.js';
import staticManagedSponsors from './js/widgets/staticManagedSponsors.js';
import scrollerSponsors from './js/widgets/scrollerSponsors.js';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Ticket Button Widget
$(document).ready(function () {
  ticketButton();
});

// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  $(document).ready(function () {
    multiScheduleFeature();
    seoWidget();
    staticManagedSponsors();
    scrollerSponsors();
  });
  $(window).load(function () {
    videoWidget();
  });
}
